import { Modal, Msg } from "@shared/components";

import { useModalSteps } from "./useModalSteps";

interface ModalStepsProps {
  showModal: boolean;
  onClose: () => void;
  onStartExam: () => void;
  isWebcamRequired: boolean;
  hasVerifiedLiveness: boolean;
  applicantExamId: string;
  isTermAccepted: boolean;
  faceVerified: boolean;
  hasReason?: boolean;
}

export const ModalSteps = ({
  showModal,
  onClose,
  onStartExam,
  isWebcamRequired,
  hasVerifiedLiveness,
  applicantExamId,
  isTermAccepted,
  faceVerified,
  hasReason,
}: ModalStepsProps) => {
  const { activeModal, goToNextStep, resetSteps, nextButtonDisabled } =
    useModalSteps(
      onStartExam,
      isWebcamRequired,
      applicantExamId,
      hasVerifiedLiveness,
      isTermAccepted,
      faceVerified,
      hasReason,
    );

  return (
    <Modal
      title={<Msg id={activeModal.titleId} />}
      isOpen={showModal}
      onClickOk={goToNextStep}
      onClose={() => {
        resetSteps();
        onClose();
      }}
      className={activeModal.className}
      cancelButtonLabel={
        activeModal.backButton?.label ? (
          <Msg id={activeModal.backButton?.label} />
        ) : null
      }
      onClickCancel={activeModal.backButton?.onClick}
      hasCancelButton={activeModal.backButton !== undefined}
      hasOkButton={Boolean(activeModal.buttonId)}
      okButtonLabel={
        activeModal.buttonId ? <Msg id={activeModal.buttonId} /> : undefined
      }
      okButtonAriaLabel={"Next"}
      disableOk={nextButtonDisabled}
      ariaLabel={"Next"}
    >
      {showModal && activeModal.component}
    </Modal>
  );
};
